import {
  AUTHENTICATION,
  LOGOUT,
  AUTHENTICATION_BY_VALID_SESSION
} from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  fetching: false, // for loading login button
  isAuthenticated: false,
  tokens: null
};

//   NOTE:  *_PENDING, *_FULFILLED and  *_REJECTED , are triggered by the promise-middleware
const authentication = (state = defaultStore, action) => {
 // console.log("authenticationreducer");

 // console.log("action",action);
  switch (action.type) {
    // Auth call
    case AUTHENTICATION:
      return { ...state };

    // Waiting for auth service response
    case AUTHENTICATION + _PENDING:
      return { ...state, fetching: true };

    // Auth successfull
    case AUTHENTICATION + _FULFILLED:
      const tokens = {
        accessToken: action.payload.accessToken.jwtToken,
        idToken: action.payload.idToken.jwtToken,
        refreshToken: action.payload.refreshToken.token
      };
      return {
        ...state,
        fetching: false,
        isAuthenticated: true,
        tokens: tokens
      };

    case AUTHENTICATION_BY_VALID_SESSION:
      return {
        ...state,
        fetching: false,
        isAuthenticated: true,
        tokens: action.payload
      };
    // Error while auth
    case AUTHENTICATION + _REJECTED:
      return { ...state, fetching: false };

    case LOGOUT:
      return { ...state, isAuthenticated: false, tokens: null };

    default:
      return state;
  }
};

module.exports = authentication;



// WEBPACK FOOTER //
// ./reducers/authenticationReducer.js